<template>
  <transition name="modal">
    <portal to="destination">
      <div class="modal-backdrop z-70" v-show="show" @click.self="$emit('close')">
        <div class="relative modal flex justify-center text-center flex-col font-mediumBig p-auto text-xm">
          <p>Текущая сессия устарела, пожалуйста перезагрузите страницу</p>
          <div class="flex w-full">
            <button class="bg-brand-yellow text-main-text py-3 rounded-full  mx-auto font-bold px-5 hover-up outline-none mt-8" @click="refreshPage">Перезагрузить страницу</button>
          </div>

        </div>
      </div>
    </portal>
  </transition>
</template>

<script>
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';

export default {
  name: 'refresh',
  data() {
    return {
      ext: '',
      show: true,
    };
  },
  methods: {
    dismiss() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
      return this.show === false;
    },
    refreshPage() {
      this.$router.go('/');
    },
  },
  created() {
    document.body.style.overflow = 'hidden';
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },
};

</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        padding: 2rem;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal {

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .modal {
        width: 27rem;
        height: 13rem;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 5px 15px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        background-color: #ffffff;
    }

    @media (max-width: 767px) {
        .hide-element {
            display: none;
        }
    }

</style>
